import { render, staticRenderFns } from "./BatchIndex.vue?vue&type=template&id=1d463a1a&scoped=true"
import script from "./BatchIndex.vue?vue&type=script&setup=true&lang=ts"
export * from "./BatchIndex.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d463a1a",
  null
  
)

export default component.exports